// constants
import { TestActionTypes } from './constants';
import { TestDataType } from 'src/types/test';
export type TestActionType = {
    type:
        | TestActionTypes.API_RESPONSE_SUCCESS
        | TestActionTypes.API_RESPONSE_ERROR
        | TestActionTypes.ADD_TEST
        | TestActionTypes.EDIT_TEST
        | TestActionTypes.GET_TEST
        | TestActionTypes.GET_TESTS
        | TestActionTypes.RESET
        | TestActionTypes.RESET_SUCCESS
        | TestActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const testApiResponseSuccess = (
    actionType: string,
    data: TestDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestActionType => ({
    type: TestActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const testApiResponseError = (
    actionType: string,
    data: TestDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestActionType => ({
    type: TestActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addTest = (params: any): TestActionType => ({
    type: TestActionTypes.ADD_TEST,
    payload: params,
});

export const editTest = (params: any): TestActionType => ({
    type: TestActionTypes.EDIT_TEST,
    payload: params,
});
export const GetTests = (params: any): TestActionType => ({
    type: TestActionTypes.GET_TESTS,
    payload: params,
});

export const GetTest = (params: any): TestActionType => ({
    type: TestActionTypes.GET_TEST,
    payload: params,
});

export const resetTest = (): TestActionType => ({
    type: TestActionTypes.RESET,
    payload: {},
});

export const resetTestSuccess = (): TestActionType => ({
    type: TestActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetTestError = (): TestActionType => ({
    type: TestActionTypes.RESET_ERROR,
    payload: {},
});
